import React from 'react';
import { Button } from './ui/button';

const Footer = () => {
  const handleSubscribe = () => {
    // Track Subscribe event with Facebook Pixel
    if (window.fbq) {
      window.fbq('track', 'Subscribe', {
        source: 'footer',
        value: 1,
        currency: 'USD'
      });
    }
    window.open('https://t.me/sinyalbankentry/12328', '_blank');
  };

  return (
    <footer className="bg-black text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-3 gap-12 max-w-6xl mx-auto">
          {/* Brand Section */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_signal-bank/artifacts/vfj5iyv4_cropped_circle_image-modified.png" 
                alt="SBE Logo" 
                className="w-12 h-12 rounded-full"
              />
              <span className="text-xl font-bold">Sinyal Bank Entry</span>
            </div>
            <p className="text-gray-400 leading-relaxed">
              Platform trading dengan teknologi AI terdepan. Membantu trader meraih profit konsisten.
            </p>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-[#ED1C24] transition-colors">Tentang Kami</a></li>
              <li><a href="#" className="hover:text-[#ED1C24] transition-colors">Testimoni</a></li>
              <li><a href="#" className="hover:text-[#ED1C24] transition-colors">FAQ</a></li>
            </ul>
          </div>
          
          {/* CTA Section */}
          <div>
            <h3 className="text-lg font-bold mb-4">Siap Join Sekarang?</h3>
            <p className="text-gray-400 mb-4">
              Bergabung dengan ribuan trader yang sudah profit konsisten
            </p>
            <Button 
              onClick={handleSubscribe}
              className="bg-[#ED1C24] hover:bg-[#c91820] text-white px-6 py-3 rounded-lg font-semibold transition-all hover:scale-105 w-full"
            >
              Join Telegram Community
            </Button>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Sinyal Bank Entry. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;